import { I as e } from "../../constants-DeVuDy8J.js";
import { createElementBlock as l, openBlock as d, normalizeClass as r, createStaticVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const n = {
  name: "DtIconGoogleMeet",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(e).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return e[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], c = /* @__PURE__ */ o('<path d="M1.5 8.5v7L4 16l2.5-.5v-7L4 8l-2.5.5Z" fill="#1E88E5"></path><path d="M18.5 12v7a1.5 1.5 0 0 1-1.5 1.5H6.5L6 18l.5-2.5h7V12l2.5-.5 2.5.5Z" fill="#4CAF50"></path><path d="M18.5 5v7h-5V8.5h-7L6 6l.5-2.5H17A1.5 1.5 0 0 1 18.5 5Z" fill="#FBC02D"></path><path d="M6.5 15.5v5H3A1.5 1.5 0 0 1 1.5 19v-3.5h5Z" fill="#1565C0"></path><path d="M6.5 3.5v5h-5l5-5Z" fill="#E53935"></path><path d="m19 12-.5 4.225-5-4.225 5-4.225L19 12Z" fill="#2E7D32"></path><path d="M23 5.055v13.89c0 .42-.49.655-.815.39l-3.685-3.11v-8.45l3.685-3.11a.501.501 0 0 1 .815.39Z" fill="#4CAF50"></path>', 7), p = [
  c
];
function _(t, f, i, m, v, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: r([a.iconSizeClass, "d-icon d-icon--google-meet"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Google Meet",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, p, 10, h);
}
const C = /* @__PURE__ */ s(n, [["render", _]]);
export {
  C as default
};
//# sourceMappingURL=google-meet.js.map
